<div class="main-content pt-4 mt-0">
  <div class="container-fluid py">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 3 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 3, 'text-white': i !== 3 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 3 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-6 mt-4">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-reg" [routerLink]="['/marketing/mediaroomRegistry']"> Registry </a>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title">
              {{ id ? "Update" : "New" }} MediaRoom Registry
            </h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Basic Identity -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="content_id"
                      >Content ID</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="content_id"
                      formControlName="content_id"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('content_id')"
                    >
                      Content ID is required
                    </div>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="title">Title</label>
                    <input
                      type="text"
                      class="form-control"
                      id="title"
                      formControlName="title"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('title')"
                    >
                      Title is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="content_type"
                      >Content Type</label
                    >
                    <select
                      class="form-control"
                      id="content_type"
                      formControlName="content_type"
                    >
                      <option *ngFor="let type of contentTypes" [value]="type">
                        {{ type | uppercase }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="pack_type"
                      >Pack Type</label
                    >
                    <select
                      class="form-control"
                      id="pack_type"
                      formControlName="pack_type"
                    >
                      <option *ngFor="let type of packTypes" [value]="type">
                        {{ type | uppercase }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-group">
                  <label class="bmd-label-floating" for="status">Status</label>
                  <div class="mt-2">
                    <span
                      class="badge"
                      [ngClass]="{
                        'badge-info': form.get('status')?.value === 'draft',
                        'badge-warning': form.get('status')?.value === 'review',
                        'badge-primary':
                          form.get('status')?.value === 'approved',
                        'badge-success':
                          form.get('status')?.value === 'published',
                        'badge-danger':
                          form.get('status')?.value === 'refresh_due',
                        'badge-secondary':
                          form.get('status')?.value === 'archived',
                      }"
                    >
                      {{ form.get("status")?.value | uppercase }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="vertical"
                      >Vertical</label
                    >
                    <select
                      class="form-control"
                      id="vertical"
                      formControlName="vertical"
                    >
                      <option *ngFor="let v of verticals" [value]="v">
                        {{ v | uppercase }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <label class="bmd-label-floating" for="consumer_targets"
                    >Consumer Targets</label
                  >
                  <mat-form-field class="compact-field">
                    <!-- <mat-label>Consumer Targets</mat-label> -->

                    <mat-select multiple formControlName="consumer_targets">
                      <mat-option *ngFor="let t of consumerTargets" [value]="t">
                        {{ t | uppercase }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="version"
                      >Version</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="version"
                      formControlName="version"
                    />
                  </div>
                </div>
              </div>

              <!-- Scope -->
              <h6 class="mt-4 mb-2">Scope Settings</h6>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="geo_scope_type"
                      >Geo Scope Type</label
                    >
                    <select
                      class="form-control"
                      id="geo_scope_type"
                      formControlName="geo_scope_type"
                    >
                      <option [ngValue]="null">None</option>
                      <option *ngFor="let type of geoScopeTypes" [value]="type">
                        {{ type | uppercase }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="geo_scope_value"
                      >Geo Scope Value</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="geo_scope_value"
                      formControlName="geo_scope_value"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="service_scope"
                      >Service Scope</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="service_scope"
                      formControlName="service_scope"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="industry_scope"
                      >Industry Scope</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="industry_scope"
                      formControlName="industry_scope"
                    />
                  </div>
                </div>
              </div>

              <!-- Request Metadata -->
              <h6 class="mt-4 mb-2">Request Metadata</h6>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="priority"
                      >Priority</label
                    >
                    <select
                      class="form-control"
                      id="priority"
                      formControlName="priority"
                    >
                      <option value="low">LOW</option>
                      <option value="medium">MEDIUM</option>
                      <option value="high">HIGH</option>
                      <option value="urgent">URGENT</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="request_type"
                      >Request Type</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="request_type"
                      formControlName="request_type"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="request_source"
                      >Source</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="request_source"
                      formControlName="request_source"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="goal">Goal</label>
                    <input
                      type="text"
                      class="form-control"
                      id="goal"
                      formControlName="goal"
                    />
                  </div>
                </div>
              </div>

              <!-- Ownership & Refresh -->
              <h6 class="mt-4 mb-2">Ownership & Refresh</h6>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="owner_primary"
                      >Owner Primary</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="owner_primary"
                      formControlName="owner_primary"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="refresh_due_at"
                      >Refresh Due Date</label
                    >
                    <input
                      type="date"
                      class="form-control"
                      id="refresh_due_at"
                      formControlName="refresh_due_at"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="refresh_cycle_days"
                      >Refresh Cycle (days)</label
                    >
                    <input
                      type="number"
                      class="form-control"
                      id="refresh_cycle_days"
                      formControlName="refresh_cycle_days"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="published_url"
                      >Published URL</label
                    >
                    <input
                      type="url"
                      class="form-control"
                      id="published_url"
                      formControlName="published_url"
                      [placeholder]="
                        form.get('status')?.value === 'approved'
                          ? 'Ex: https://courierandbeyond.com/miami-courier'
                          : ''
                      "
                    />
                    <small
                      *ngIf="form.get('status')?.value === 'approved'"
                      class="text-info"
                    >
                      * Required for publishing.
                    </small>
                  </div>
                </div>
              </div>

              <!-- Operational Metadata (Read-only) -->
              <div class="row mt-4" *ngIf="id">
                <div class="col-md-3">
                  <p class="small text-muted mb-0">Approved By</p>
                  <p class="fw-bold">
                    {{ form.get("approved_by")?.value || "N/A" }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p class="small text-muted mb-0">Approved At</p>
                  <p class="fw-bold">
                    {{ (form.get("approved_at")?.value | date) || "N/A" }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p class="small text-muted mb-0">Last Refresh</p>
                  <p class="fw-bold">
                    {{ (form.get("last_refresh_at")?.value | date) || "N/A" }}
                  </p>
                </div>
                <div class="col-md-3">
                  <p class="small text-muted mb-0">Refresh Due</p>
                  <p class="fw-bold">
                    {{ (form.get("refresh_due_at")?.value | date) || "N/A" }}
                  </p>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="change_log_summary"
                      >Change Log Summary</label
                    >
                    <textarea
                      class="form-control"
                      id="change_log_summary"
                      formControlName="change_log_summary"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
              </div>

              <div class="row text-center mt-4">
                <div
                  class="col-md-12 d-flex justify-content-end gap-2"
                  style="gap: 10px"
                >
                  <!-- Transitions -->
                  <button
                    *ngIf="
                      id &&
                      (form.get('status')?.value === 'draft' ||
                        form.get('status')?.value === 'refresh_due')
                    "
                    type="button"
                    class="btn btn-warning btn-sm"
                    (click)="submitReview()"
                  >
                    <i class="fas fa-paper-plane me-1"></i> Submit for Review
                  </button>

                  <button
                    *ngIf="id && form.get('status')?.value === 'review'"
                    type="button"
                    class="btn btn-success btn-sm"
                    (click)="approveContent()"
                  >
                    <i class="fas fa-check me-1"></i> Approve
                  </button>

                  <button
                    *ngIf="id && form.get('status')?.value === 'approved'"
                    type="button"
                    class="btn btn-primary btn-sm"
                    (click)="publishContent()"
                  >
                    <i class="fas fa-globe me-1"></i> Publish
                  </button>

                  <button
                    *ngIf="id && form.get('status')?.value === 'published'"
                    type="button"
                    class="btn btn-info btn-sm"
                    (click)="updateStatus('refresh_due')"
                  >
                    <i class="fas fa-sync me-1"></i> Mark as Refresh Due
                  </button>

                  <button
                    *ngIf="id && form.get('status')?.value !== 'archived'"
                    type="button"
                    class="btn btn-outline-secondary btn-sm"
                    (click)="archiveContent()"
                  >
                    <i class="fas fa-archive me-1"></i> Archive
                  </button>

                  <button
                    *ngIf="id && form.get('status')?.value === 'archived'"
                    type="button"
                    class="btn btn-outline-success btn-sm"
                    (click)="updateStatus('draft')"
                  >
                    <i class="fas fa-undo me-1"></i> Unarchive
                  </button>

                  <!-- General Save -->
                  <button
                    type="submit"
                    class="btn btn-dark btn-sm"
                    [disabled]="form.invalid"
                  >
                    <i class="fas fa-save me-1"></i>
                    {{ id ? "Update" : "Create" }}
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
